module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "company-videos"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "-webkit-touch-callout": "none",
      "height": "100%",
      "overflow-y": "scroll",
      "width": "100%"
    }
  }, [(_vm.isRequestActive) ? _c('div', {
    staticClass: "loader"
  }, [_c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15,
      "color": _vm.customization.mainColor
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isRequestActive) ? _c('div', {
    staticClass: "layout_fullwidth_padding"
  }, [_c('h3', [_vm._v("Company Videos")]), _vm._v(" "), _c('div', {
    staticClass: "company-video",
    staticStyle: {
      "text-align": "center"
    }
  }, _vm._l((_vm.videos), function(video, key) {
    return _c('youtube', {
      key: key,
      attrs: {
        "player-vars": _vm.playerVars,
        "video-id": video.youtubeKey,
        "width": "100%"
      }
    })
  }), 1)]) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6195060c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6195060c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/company-video.vue
// module id = 839
// module chunks = 0